export default "__VITE_ASSET__c9987570__"